export default __webpack_public_path__ + "static/media/infinity.806b74cb.svg";